module.exports = __webpack_public_path__ + "static/media/grid-item-b13.8bf516eb.png";